module.exports = __webpack_public_path__ + "static/media/jumbotron__image--9.f3058205.jpg";